import { Directive, ElementRef, OnInit, inject } from "@angular/core";

@Directive({ selector: "[mnClickArea]", host: { "(window:resize)": "resize()" } })
export class ClickAreaDirective implements OnInit {
  private readonly eR = inject<ElementRef<HTMLElement>>(ElementRef);

  private readonly WIDTH = 768;
  private readonly AREA = 12;

  public ngOnInit(): void {
    this.element.style.setProperty("--t-a-e", `-${this.AREA}px`);

    this.resize();
  }

  public resize(): void {
    if (this.mobile) {
      this.element.classList.add("click-area");
    } else {
      this.element.classList.remove("click-area");
    }
  }

  private get mobile(): boolean {
    return window.innerWidth <= this.WIDTH;
  }

  private get element(): HTMLElement {
    return this.eR.nativeElement;
  }
}
